import React from 'react'
import logo from 'assets/img/logo.svg'
import { ForgotPasswordForm } from 'components'
import { useTranslation } from 'react-i18next'

export const ForgotPassword = () => {

    const { t } = useTranslation();

    return (
        <ForgotPasswordForm />
    )
}
